<template>
  <v-dialog ref="dialog" v-model="menu" width="290px">
    <v-date-picker
      v-model="date"
      scrollable
      v-bind="$props"
      dense
      class="border-radius: 20px 20px 20px 0px !important;"
      @input="onInput"
    >
    </v-date-picker>
    <template #activator="{ on }">
      <div :style="{ flex: hideAppend ? '1 1 0 !important' : '' }">
        <div style="display: inline-block" :style="{ width: fullWidth && '100%' }" v-on="on">
          <slot v-bind="{ computedDate: computedDateFormatted }"></slot>
        </div>
        <div style="display: inline-block">
          <slot name="append"></slot>
        </div>
      </div>
    </template>
  </v-dialog>
</template>

<script>
import dayjs from 'dayjs'
export default {
  props: {
    value: {
      //
    },
    min: {
      //
    },
    max: {
      //
    },
    allowedDates: {
      //
    },
    format: {
      default: 'DD/MM/YYYY'
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    hideAppend: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      date: this.value,
      menu: false
    }
  },
  computed: {
    computedDateFormatted() {
      if (!this.date) return ''
      return dayjs(this.date).format(this.format)
    }
  },

  watch: {
    value(newVal, oldVal) {
      if (newVal != oldVal) {
        this.date = newVal
      }
    }
  },

  methods: {
    onInput(date) {
      this.menu = false
      this.$emit('input', date)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/DatePicker.vue